import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import SectionContact from '../components/SectionContact';
import Bande from '../components/Bande';
import Reveal from '../components/Reveal';
import TitreSection from '../components/TitreSection';
import AppelAction from '../components/AppelAction';
import { ENTREPRISE, COMMUNES_LISTE, COMMUNES_PAGES, ETAPES } from '../data/site';

export default function Livraison() {
  return (
    <>
      <Seo
        titre="Livraison d'engins de chantier en Île-de-France | Alfortville 94"
        description="Nous livrons mini-pelles et chariot télescopique sur votre chantier partout en Île-de-France, sous 24 à 48 h, au départ d'Alfortville (94). Reprise en fin de location incluse."
      />

      <section className="bg-nuit text-white relative overflow-hidden">
        <div className="absolute inset-0 trame-diagonale" aria-hidden="true" />
        <div className="conteneur relative py-14 sm:py-16">
          <div className="grid lg:grid-cols-[1.1fr_0.9fr] gap-10 items-center">
            <div>
              <h1 className="font-display uppercase text-[36px] sm:text-[48px] leading-[1]">
                On vient, on <span className="mot-degrade">décharge</span>, vous travaillez
              </h1>
              <p className="mt-5 text-white/75 max-w-xl text-[18px]">
                Sous 24 à 48 h sur votre chantier, partout en Île-de-France, au départ de notre
                dépôt d'Alfortville. Vous n'immobilisez ni votre camion, ni votre chauffeur.
              </p>
              <div className="mt-7 flex flex-col sm:flex-row gap-3">
                <Link to="/contact" className="btn-jaune">Demander mon devis</Link>
                <a href={ENTREPRISE.telephoneLien} className="btn-contour">{ENTREPRISE.telephone}</a>
              </div>
            </div>
            <div className="relative">
              <div className="absolute -inset-x-3 -bottom-2 h-2 bande-chantier" aria-hidden="true" />
              <img
                src="/images/ecr25d-chargee.jpg"
                alt="Mini-pelle sanglée sur son porte-engins avant départ en livraison sur chantier"
                className="photo-entiere relative rounded-[4px] shadow-haut max-h-[420px] w-auto mx-auto"
              />
            </div>
          </div>
        </div>
        <Bande hauteur={6} />
      </section>

      <section className="bg-white py-14 sm:py-16">
        <div className="conteneur">
          <TitreSection avant="Le transport, c'est la moitié du " mot="problème" />
          <div className="mt-8 max-w-3xl space-y-5 text-nuit/85 text-[17px]">
            <p>
              En petite couronne, aller chercher une machine soi-même revient souvent plus cher
              que la location. Il faut un porte-engins disponible, un chauffeur, un créneau de
              stationnement, et il faut composer avec les restrictions de circulation qui touchent
              une large part des entreprises franciliennes du bâtiment.
            </p>
            <p>
              Nous livrons et nous reprenons la machine. Votre camion reste sur votre chantier,
              votre conducteur reste à sa machine, et vous ne perdez pas une demi-journée en trajet.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-trame py-14 sm:py-16">
        <div className="conteneur">
          <TitreSection avant="De l'appel à la " mot="machine" />
          <ol className="mt-9 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {ETAPES.map((e, i) => (
              <Reveal key={e.num} delai={i * 0.07}>
                <li className="carte p-6 h-full">
                  <span className="font-display text-[34px] leading-none text-jaune">{e.num}</span>
                  <h3 className="font-cond uppercase font-bold tracking-[0.03em] text-[18px] text-nuit mt-3">
                    {e.titre}
                  </h3>
                  <p className="mt-2 text-nuit/75 text-[15.5px]">{e.texte}</p>
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
      </section>

      <AppelAction titre="Votre chantier est loin d'Alfortville ?" texte="Donnez-nous la commune, on vous confirme le délai et les conditions de livraison en quelques heures." />

      <section className="bg-white py-14 sm:py-16">
        <div className="conteneur">
          <TitreSection avant="Les communes que nous " mot="desservons" />
          <p className="mt-4 max-w-2xl text-nuit/75">
            Cette liste n'est pas limitative. Si votre commune n'y figure pas, appelez-nous :
            nous intervenons dans toute l'Île-de-France.
          </p>

          <div className="mt-8">
            <h3 className="font-cond uppercase font-bold tracking-[0.06em] text-[17px] text-nuit mb-4">
              Nos pages par commune
            </h3>
            <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
              {COMMUNES_PAGES.map((c) => (
                <Link
                  key={c.slug}
                  to={`/location-engins-chantier-${c.slug}`}
                  className="carte px-5 py-4 hover:border-jaune transition-colors flex items-center justify-between gap-3"
                >
                  <span className="font-cond uppercase font-bold tracking-[0.04em] text-[16px] text-nuit">
                    {c.nom}
                  </span>
                  <span className="text-beton text-[14px]">{c.cp}</span>
                </Link>
              ))}
            </div>
          </div>

          <div className="mt-10">
            <h3 className="font-cond uppercase font-bold tracking-[0.06em] text-[17px] text-nuit mb-4">
              Nous livrons également
            </h3>
            <ul className="flex flex-wrap gap-2.5">
              {COMMUNES_LISTE.map((c) => (
                <li
                  key={c}
                  className="font-cond uppercase tracking-[0.06em] text-[14px] bg-trame text-nuit px-3.5 py-2 border-l-2 border-bleu"
                >
                  {c}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <SectionContact
        avant="Dites-nous où livrer votre "
        mot="machine"
        intro="La commune du chantier, vos dates et la largeur de l'accès suffisent. On vous confirme le délai et le tarif en quelques heures."
      />
    </>
  );
}
